<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header" v-if="showDialogHeader">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px"
            >{{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm12 md4>
              <div style="padding: 20px 10px">
                <p class="font-weight-bold">
                  Số đề nghị:
                  {{ createItem.requestNumber }}
                </p>
                <p class="font-weight-bold">
                  Người đề nghị xuất kho:
                  {{ createItem.userCreateName }}
                </p>
                
                <div v-if="isEdit && (exportRequest.exportedTime == null || exportRequest.exportedTime == '') && exportRequest.status <= 2">
                    <i-datepicker
                        label="Ngày xuất kho yêu cầu"
                        v-model="createItem.exportDate"
                        :minDate="minDate()"
                        @change="onChangeExportDate()"
                    />
                </div>
                <p v-else class="font-weight-bold">
                  Ngày xuất kho yêu cầu:
                  {{ formatDate(createItem.exportDate) }}
                </p>
                <div>
                  <v-autocomplete
                      :items="lstMaterialTypeAlly"
                      label="Nhóm của nhóm vật tư"
                      v-model="createItem.materialTypeAllyId"
                      item-value="categoryId"
                      item-text="categoryName"
                      disabled
                  />
                </div>
                <div v-if="isEdit && exportRequest.status <= 2">
                    <v-select
                        :items="lstMaterialTypeSelect"
                        label="Chọn nhóm vật tư"
                        v-model="materialTypeSelected"
                        item-value="categoryId"
                        item-text="categoryName"
                        @change="onChangeMatType($event)"
                        multiple
                    />
                </div>

                <p class="font-weight-bold">
                  Trạng thái:
                  <span v-if="exportRequest.status == 6" style="color: green">{{exportStatusName()}}</span>
                  <span v-else style="color: #d9d900">{{exportStatusName()}}</span>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <div style="padding: 20px 10px">
                <p class="font-weight-bold">
                  Khu nuôi: {{ areaCode }}
                </p>
                <p class="font-weight-bold">
                  Vụ nuôi: {{ cropName }}
                </p>
                <p class="font-weight-bold">
                  Quy trình nuôi: {{ procedureCode }}
                </p>
                <p class="font-weight-bold">
                  Người nuôi: {{ famerName }}
                </p>
                <p class="font-weight-bold">
                  Ngày tuổi tôm: {{ createItem.shrimpAge }}
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md4>
              <div>
                <v-select
                    :label="$t('Chọn G')"
                    :items="numberGList"
                    item-text="text"
                    item-value="value"
                    name="numberG"
                    ref="numberG"
                    v-model="createItem.numberG"
                    disabled
                />
              </div>
              <div>
                <v-select
                    :items="timeAm"
                    label="Sáng"
                    v-model="timeAmSelected"
                    item-value="value"
                    item-text="text"
                    @change="onChangeTime($event, 'am')"
                    multiple
                    :disabled="!isEdit || exportRequest.isExportAm == 1 || exportRequest.status > 2"
                />
              </div>
              <div>
                <v-select
                    :items="timePm"
                    label="Chiều"
                    v-model="timePmSelected"
                    item-value="value"
                    item-text="text"
                    @change="onChangeTime($event, 'pm')"
                    multiple
                    :disabled="!isEdit || exportRequest.isExportPm == 1 || exportRequest.status > 2"
                />
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <div v-if="isEdit || showApprove || showReject">
                  <v-textarea
                    outlined
                    v-validate="'max:500'"
                    label="Ghi chú"
                    rows="2"
                    v-model="createItem.content"
                    name="request_content"
                    data-vv-as="Ghi chú"
                    :error-messages="errors.first('request_content')"
                />
              </div>
              <p v-else class="font-weight-bold">
                  Ghi chú: {{ exportRequest != null ? exportRequest.content : '' }}
              </p>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <table class="lstTable">
                <tr>
                  <th rowspan="2">{{ $t('lang.material.materialType') }}</th>
                  <th rowspan="2">Tên vật tư</th>
                  <th rowspan="2" width="80">Đơn vị</th>
                  <th rowspan="2" width="150">Số lượng theo quy trình</th>
                  <th rowspan="2" width="100">Tồn kho</th>
                  <th :colspan="timeAmSelected !=undefined && timeAmSelected.length == 0 ? 1 : timeAmSelected.length">Sáng</th>
                  <th :colspan="timePmSelected != undefined && timePmSelected.length == 0 ? 1 : timePmSelected.length">Chiều</th>
                  <th rowspan="2">Tổng đề xuất</th>
                  <th rowspan="2" v-if="isDirector">Đơn giá</th>
                  <th rowspan="2" v-if="isDirector">Thành tiền</th>
                </tr>
                <tr>
                  <th v-if="timeAmSelected.length == 0" width="60"></th>
                  <template v-else v-for="(item, index) in timeAmSelected">
                    <th :key="'am1'+index" width="60">{{ item }}h</th>
                  </template>

                  <th v-if="timePmSelected.length == 0" width="60"></th>
                  <template v-else v-for="(item, index) in timePmSelected">
                    <th :key="'pm1'+index" width="60">{{ item }}h</th>
                  </template>
                </tr>
                <template v-for="(item, index) in lstMaterial">
                  <tr v-if="item.row === 0" :key="'mat'+index">
                    <td style="font-weight: bold">{{ item.typeName }}</td>
                    <td colspan="7">Không có vật tư</td>
                  </tr>
                  <tr v-else :key="'mat'+index">
                    <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0"
                        style="font-weight: bold">{{ item.typeName }}
                    </td>
                    <td>{{ item.materialName }}</td>
                    <td style="text-align: center">{{ item.unit }}</td>
                    <td style="text-align: center">{{ item.total | currency }}</td>
                    <td style="text-align: center">{{ item.inventory | currency }}</td>

                    <td v-if="lstMaterial[index].quantityAm.length == 0"></td>
                    <template v-else v-for="(v2, k2) in lstMaterial[index].quantityAm">
                      <td v-if="lstMaterial[index].quantityAm[k2] != undefined" :key="'am' + k2">
                        <c-input-number
                            v-model="lstMaterial[index].quantityAm[k2].value"
                            @keydown="keyProcess"
                            @change="onInputChangeTextBoxFloat($event, index)"
                            :id="'input_' + index + '_' + k2"
                            :data-row="index"
                            :data-col="k2"
                            data-time="am"
                            :disabled="item.inventory == 0 || !isEdit || timeExported(v2.time) ? true : false"
                        />
                      </td>
                      <td v-else :key="'am' + k2"></td>
                    </template>

                    <td v-if="lstMaterial[index].quantityPm.length == 0"></td>
                    <template v-else v-for="(v3, k3) in lstMaterial[index].quantityPm">
                      <td v-if="lstMaterial[index].quantityPm[k3] != undefined" :key="'pm' + k3">
                        <c-input-number
                            v-model="lstMaterial[index].quantityPm[k3].value"
                            @keydown="keyProcess"
                            @change="onInputChangeTextBoxFloat($event, index)"
                            :id="'input_' + index + '_' + (lstMaterial[index].quantityAm.length + k3)"
                            :data-row="index"
                            :data-col="lstMaterial[index].quantityAm.length + k3"
                            :data-col2="k3"
                            data-time="pm"
                            :disabled="item.inventory == 0 || !isEdit || timeExported(v3.time) ? true : false"
                        />
                      </td>
                      <td v-else :key="'pm' + k3"></td>
                    </template>

                    <td style="text-align: center">
                      <div v-bind:style="{ color: item.total_export >  item.total ? 'red' : ''}" >{{ item.total_export | currency }}</div>
                    </td>
                    <td style="text-align: center" v-if="isDirector">
                      {{ item.price | currency }}
                    </td>
                    <td style="text-align: center" v-if="isDirector">
                      {{ item.amount | currency }}
                    </td>
                  </tr>
                </template>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="info" @click="historyDlg=true" v-if="exportRequest != undefined && exportRequest.exportId != undefined && exportRequest.exportId != null">
            {{ $t("lang.common.history") }}
          </v-btn>
          <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
            {{ $t("Phê duyệt") }}
          </v-btn>
          <v-btn v-if="showReject" color="error" @click="openDialogRejectApprove" :disabled="loading">
            {{ $t("Không phê duyệt") }}
          </v-btn>

<!--          <v-btn v-if="showConfirm" color="success" @click="onConfirm" :disabled="loading">-->
<!--            {{ $t("Xác nhận") }}-->
<!--          </v-btn>-->
          <v-btn v-if="showConfirm" color="success" @click="onSaveAndConfirm" :disabled="loading">
            {{ $t("Xác nhận") }}
          </v-btn>
          <v-btn v-if="showUpdate" color="primary" @click="onSave" :disabled="loading">
            {{ $t("lang.common.update") }}
          </v-btn>
          <v-btn v-if="showCancel" color="error" @click="openDialogCancelExport" :disabled="loading">
            {{ $t("Hủy phiếu") }}
          </v-btn>
          <v-btn v-if="showDelete" color="error" @click="onDeleteExport" :disabled="loading">
            {{ $t("lang.common.delete") }}
          </v-btn>
          <v-btn v-if="showPrint" color="info" @click="onPrint" :disabled="loading">
            {{ $t("In phiếu") }}
          </v-btn>
          <v-btn color="warning" @click="onCancel" :disabled="loading">
            {{ $t("lang.common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <dialog-reject-approve 
      :dialog="dialogRejectApprove"
      @close="closeDialogRejectApprove"
      @onRejectApprove="onRejectApprove"
    />
    <dialog-cancel-export
        :dialog="dialogCancelExport"
        @close="closeDialogCancelExport"
        @onCancelExport="onCancelExport"
    />
    <dialog_history :dialog="historyDlg" :lst-history="lstHistory" @close="closeHistory"/>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import {areaContants, roleConstants, requestConstants} from "@/constants";
import DialogRejectApprove from "./component/DialogRejectApprove.vue";
import DialogCancelExport from "@/views/admin/export_request/component/DialogCancelExport";
import Dialog_history from "@/views/admin/export_request/component/DialogHistory";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
  name: "ExportRequestView",
  components: {CTextboxFloat, Dialog_history, DialogCancelExport, IDatepicker, DialogRejectApprove},
  props: {
    exportId: {
      type: [String,Number],
      default: "-1"
    },
    showDialogHeader: {
      type: Boolean,
      default: true,
    },
    fromSummary: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      exportIdIn: "-1",
      formName: "Tạo đề nghị xuất kho theo quy trình",
      dialogRejectApprove: false,
      dialogCancelExport: false,
      loading: false,
      roleGroup: 1,
      warehouseId: '',
      cropName: '',
      areaCode: '',
      procedureCode: '',
      famerName: '',
      timeAmSelected: [],
      timePmSelected: [],
      numberGList: areaContants.numberGList,
      materialTypeAllyId: "-1",
      lstG: [],
      timeAm: [],
      timePm: [],
      materials: [],
      lstSupplier: [],
      lstMaterialType: [],
      lstMaterialTypeAlly:[],
      lstMaterialTmp: [],
      lstMaterial: [],
      lstMaterialCurrent: [],
      lstImportWh: [],
      lstUser: [],
      lstProcedureData: [],
      lstMaterialPrice: [],
      requestOrder: null,
      isEdit: false,
      role: '',
      lstMaterialTypeSelect: [],
      materialTypeSelected: '-1',
      exportRequest: {
        isExportAm: 0,
        isExportPm: 0,
        status: 0,
      },
      createItem: {
        requestNumber: '',
        userCreateId: '',
        userCreateName: '',
        cropId: '',
        numberG: 1,
        exportType: 1,
        shrimpAge: '',
        status: 0,
      },
      historyDlg: false,
      lstHistory: [],
    };
  },

  created() {
    //alert(this.$route.params.in);
    // 4: kỹ sư trưởng
    const role = parseInt(this.$store.state.auth.user.role);
    if (role == 4) {
      this.roleGroup = 2;
    }
    if (this.exportId != undefined && this.exportId != "" && this.exportId != "-1") {
      this.exportIdIn = this.exportId;
    } else if (this.$route.params.id != undefined && this.$route.params.id != "") {
      this.exportIdIn = this.$route.params.id;
    }
    this.getMaterialTypeAlly();

  },
  computed: {
    isDirector() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
        return true;
      } else {
        return false;
      }
    },
    showApprove() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },
    showReject() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed) {
        return true;
      } else {
        return false;
      }
    },

    showRejectConfirm() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.created) {
        return true;
      } else {
        return false;
      }
    },
    showCancel  () {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
          && this.exportRequest.status == areaContants.exportRequestStatus.approved) {
        return true;
      } else {
        return false;
      }
    },
    showUpdate() {
      // return true;
      if (
          (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.created)
          || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.created)
          || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed)
          || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.approved)
          || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.incomplete)) {
        return true;
      } else {
        return false;
      }
    },
    showConfirm () {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.created) {
        return true;
      } else {
        return false;
      }
    },
    showPrint () {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER
          || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.approved) {
        return true;
      } else {
        return false;
      }
    },
    showDelete() {
      if(this.$store.state.auth.user.userId != this.exportRequest.userCreateId){
        return false;
      }
      if (
          (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.rejected)
         || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
              && this.exportRequest.status == areaContants.exportRequestStatus.confirmed)
         || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
              && this.exportRequest.status == areaContants.exportRequestStatus.created)
          || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.rejected)
          || (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
          && this.exportRequest.status == areaContants.exportRequestStatus.confirmed)
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    exportId: function (value) {
      this.exportIdIn = value;
    },
    exportIdIn: function (value) {
      this.getExportRequest(value);
      // this.setTimeList();
      this.getMaterialType();
    },
  },

  methods: {
    onCancel() {
      //this.$router.push({path: '/exportRequest'});
      this.$router.push({ path: `/exportRequest`, query: this.$route.query });

    },
    getMaterialTypeAlly() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE_ALLY"
      ).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialTypeAlly = data;
            }
          }
      );
    },
    onSave(type) {
      // const total_export = this.lstMaterial.reduce((n, {total_export}) => n + total_export, 0)
      // if (parseFloat(total_export) <= 0) {
      //   message.error("Bạn chưa nhập số lượng vật tư xuất kho");
      //   return;
      // }

      const lstMaterial_tmp = this.lstMaterial;
      let rt = true;
      // console.log(lstMaterial_tmp);
      $.each(lstMaterial_tmp, function (k, v) {
          if (parseFloat(v.inventory) > 0) {
              $.each(v.quantityAm, function (k2, v2) {
                  if (v2.value === '') {
                      message.error("Có vật tư chưa nhập số lượng xuất kho");
                      rt = false;
                  }
              });
              $.each(v.quantityPm, function (k2, v2) {
                  if (v2.value === '') {
                      message.error("Có vật tư chưa nhập số lượng xuất kho");
                      rt = false;
                  }
              });

              if (v.total_export === '') {
                  message.error("Có vật tư chưa nhập số lượng xuất kho");
                  rt = false;
              }
              if (parseFloat(v.total_export) > parseFloat(v.inventory)) {
                  message.error("Tổng đề xuất không được vượt quá số lượng tồn kho");
                  rt = false;
              }
              if (parseFloat(v.total_export) > parseFloat(v.total)) {
                  message.error("Tổng đề xuất không được vượt quá số lượng theo quy trình");
                  rt = false;
              }
              // if (parseFloat(v.total_export) < parseFloat(v.total/2) && parseFloat(v.total_export) != 0) {
              //     console.log(v.total_export)
              //   console.log(v.total/2)
              //     message.error(" Tổng đề xuất không được nhỏ hơn 50% lượng theo quy trình");
              //     rt = false;
              // }
          }
      });
      if(!rt){
        return;
      }

      const createItem = this.createItem;
      createItem.requestData = JSON.stringify(this.lstMaterial);
      // console.log(createItem);
      // return;
      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/save", createItem)
          .then(
              (data) => {
                if (data.success) {
                  message.success(
                      this.$t("lang.common.save_success")
                  );
                  if(type == "confirm"){
                    this.onConfirm();
                  }
                  if(!this.fromSummary){
                    this.onCancel();
                  } else{
                    this.$router.go(0);
                  }
                } else {
                  message.error(this.$t(data.description));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onCancelExport(reason) {
      this.loading = true;
      this.exportRequest.reason = reason
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", this.exportRequest)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  this.onCancel();
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onApprove() {
      const exportRequest = this.exportRequest;
      exportRequest.requestData = JSON.stringify(this.lstMaterial);

      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/approve", exportRequest)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  if(!this.fromSummary){
                    this.onCancel();
                  } else{
                    this.$router.go(0);
                    //this.$router.push({path: '/exportRequest/confirm/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.requestDate});
                  }
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },

    onRejectApprove(reason = '') {

      this.loading = true;
      const exportRequest = this.exportRequest;
      exportRequest.reason = reason;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", exportRequest)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  if(!this.fromSummary){
                    this.onCancel();
                  } else{
                    this.$router.go(0);
                    //this.$router.push({path: '/exportRequest/approve/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.exportDate});
                  }
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.closeDialogRejectApprove();
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onConfirm() {
      this.loading = true;

      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/confirm", this.exportRequest)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  if(!this.fromSummary){
                    this.onCancel();
                  } else{
                    this.$router.go(0);
                    //this.$router.push({path: '/exportRequest/confirm/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.requestDate});
                  }
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onSaveAndConfirm(){
      this.onSave("confirm");
    },

    onRejectConfirm() {
      this.loading = true;
      axios
          .post(process.env.VUE_APP_API_URL + "/exportRequest/reject", this.exportRequest)
          .then(
              (data) => {
                if (data.success) {
                  message.success(this.$t("lang.common.save_success"));
                  if(!this.fromSummary){
                    this.onCancel();
                  } else{
                    this.$router.go(0);
                    //this.$router.push({path: '/exportRequest/confirm/' + this.exportRequest.areaId + "/requestDate/"+ this.exportRequest.requestDate});
                  }
                } else {
                  message.error(this.$t("lang.common.save_error"));
                }
                this.loading = false;
              },
              (error) => {
                this.loading = false;
                console.log(error);
              }
          );
    },
    onDeleteExport() {
        if (confirm(this.$t("lang.common.deleteConfirm"))) {
            this.loading = true;
            axios
            .post(process.env.VUE_APP_API_URL + "/exportRequest/delete", this.exportRequest)
            .then(
                (data) => {
                  if (data) {
                    message.success(this.$t("lang.common.delete_success"));
                    this.onCancel();
                  } else {
                    message.error(this.$t("lang.common.deleteError"));
                  }
                  this.loading = false;
                },
                (error) => {
                  this.loading = false;
                  console.log(error);
                }
            );    
        }
    },
    onPrint() {
      axios({
        url: process.env.VUE_APP_API_URL + "/exportRequest/exportExcel",
        method: "POST",
        data: this.exportRequest,
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "De_nghi_xuat_kho" + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    getExportRequest(exportId) {
      if (exportId != -1) {
        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportRequest/search?pageSize=-1&page=-1",
                {exportId: exportId}
            )
            .then((data) => {
              if (data.items) {
                const exportRequest = data.items[0];
                //linhdx
                this.materialTypeAllyId = exportRequest.materialTypeAllyId
                exportRequest.exportDate = moment(String(exportRequest.exportDate)).format('YYYY-MM-DD');

                this.getCrop(exportRequest.cropId);
                this.getPondArea(exportRequest.areaId);
                
                this.lstMaterial = JSON.parse(exportRequest.requestData);
                //linhdx check if lstMaterialCurrent quantityAm undefined
                for(let i = 0; i< this.lstMaterial.length; i++){
                  let obj = this.lstMaterial[i];
                  if(obj.quantityAm== undefined){
                    obj.quantityAm=[];
                  }
                  if(obj.quantityPm== undefined){
                    obj.quantityPm=[];
                  }
                }
                this.lstMaterialCurrent = JSON.parse(exportRequest.requestData);
                //linhdx check if lstMaterialCurrent quantityAm undefined
                for(let i = 0; i< this.lstMaterialCurrent.length; i++){
                  let obj = this.lstMaterialCurrent[i];
                  if(obj.quantityAm== undefined){
                    obj.quantityAm=[];
                  }
                  if(obj.quantityPm== undefined){
                    obj.quantityPm=[];
                  }
                }
                this.formatTimeSelected(this.lstMaterial[0]);
                // console.log(exportRequest);
                this.createItem = exportRequest;
                // console.log(this.createItem);
                this.exportRequest = exportRequest;
                this.getHistory(this.exportRequest);

                this.setIsEdit();
                // if (exportRequest.status != 1 && this.roleGroup == 1) {
                //   this.isDisabled = true;
                // }
                this.setTimeList();
                // this.getMaterialPrice();
              }
            });
      }
    },
    getCrop(cropId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1",
          {cropId: cropId}
      )
          .then((data) => {
            if (data.items) {
              this.crop = data.items[0];
              this.cropName = data.items[0].name;

              // this.getEnvMeasure();
              // this.getPondArea(data.items[0].pondAreaId);
              this.getUser(data.items[0].users);
              // this.getShrimpAge(data.items[0]);
              this.getProcedureDetail(data.items[0].processId);
            }
          });
    },
    getPondArea(areaId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
          {categoryId: areaId}
      )
          .then((data) => {
            if (data.items) {
              this.areaCode = data.items[0].categoryName;
              this.getWarehouse(data.items[0].categoryId);
            }
          });
    },
    getWarehouse(parentId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=WAREHOUSE&pageSize=-1&page=-1",
          {parentId: parentId}
      )
          .then((data) => {
            if (data.items) {
              this.warehouseId = data.items[0].categoryId;
              this.getWarehouseInventory(data.items[0].categoryId);
            }
          });
    },
    getWarehouseInventory(warehouseId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/warehouse/search?pageSize=-1&page=-1",
          {warehouseId: warehouseId}
      )
          .then((data) => {
            if (data.items) {
              this.lstInventory = data.items;
            }
          });
    },
    // setMaterialInventory(data) {
    //     console.log(this.lstMaterial);
    //     $.each(this.lstMaterial, function (k, v) {

    //     });
    // },
    getProcedureDetail(procedureId) {
      axios.post(process.env.VUE_APP_API_URL + "/procedureWh/detail/" + procedureId,
          {numberG: this.createItem.numberG}
      ).then(
          data => {
            this.procedureCode = data.procedureWh.codeIncludeNote;
            this.lstProcedureData = data;
            //this.reCalculate();
            this.setMatTypeSelect();
          }
      )
    },
    getUser(stringUser) {
      const uArr = stringUser.split(",");
      axios.post(
          process.env.VUE_APP_API_URL + "/user/list", {}
      )
          .then((data) => {
            if (data.content.length > 0) {
              const lstUser = data.content;
              const famers = lstUser.filter(function (e) {
                return uArr.indexOf(String(e.userId)) != -1;
              });
              if (famers) {
                let listUser = ''
                $.each(famers, function (k, v) {
                  if (k == 0) {
                    listUser += v.fullName;
                  } else {
                    listUser += ", " + v.fullName;
                  }
                });
                this.famerName = listUser;
              }
            }
          });
    },
    getImportWh(reqOrdId) {
      axios.post(
          process.env.VUE_APP_API_URL + "/importWh/search?pageSize=-1&page=-1",
          {status: 1, reqOrdId: reqOrdId}
      )
          .then((data) => {
            if (data.items) {
              this.lstImportWh = data.items;
            }
            this.calcTotalImportQuantity();
          });
    },
    getMaterialType() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
      ).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialType = data;
            }
          }
      );
    },
    // getEnvMeasure() {
    //     axios.post(
    //             process.env.VUE_APP_API_URL + "/envMeasure/search?pageSize=1&page=1",
    //             {cropId: this.createItem.cropId}
    //         )
    //         .then((data) => {
    //             if (data.items) {
    //                 this.envMeasure = data.items;
    //                 if (data.items[0].am != undefined) {
    //                     let amIndex = JSON.parse(data.items[0].am);
    //                     let g = amIndex.g.replace('G', '');
    //                     this.createItem.numberG = parseInt(g);
    //                 }
    //             }
    //         });
    // },

    keyProcess($event) {
      let group = 'input';
      let row = parseInt($event.target.getAttribute("data-row"));
      let col = parseInt($event.target.getAttribute("data-col"));
      switch ($event.keyCode) {
        case 13:
          col += 1;
          let id = group + '_' + row + '_' + col;
          var element = document.getElementById(id);
          if (typeof (element) != 'undefined' && element != null) {
            element.focus();
          } else {
            row += 1;
            col = 0;
            id = group + '_' + row + '_' + col;
            element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            } else {
              document.getElementById($event.target.getAttribute("id")).blur();
            }
          }
          $event.preventDefault();
          break;
        case 37:
          // left
          if (col >= 0) {
            col -= 1;
            let id = group + '_' + row + '_' + col;
            let element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 38:
          // up
          if (row >= 0) {
            row -= 1;
            let id = group + '_' + row + '_' + col;
            let element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 39:
          //right
          if (col >= 0) {
            col += 1;
            let id = group + '_' + row + '_' + col;
            // document.getElementById(id).focus();
            var element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
        case 40:
          //down
          if (row >= 0) {
            row += 1;
            let id = group + '_' + row + '_' + col;
            var element = document.getElementById(id);
            if (typeof (element) != 'undefined' && element != null) {
              element.focus();
            }
          }
          $event.preventDefault();
          break;
      }
    },
    minDate() {
      const minDate = moment().format('YYYY-MM-DD');
      return minDate;
    },
    onChangeG(event) {
      console.log(event);
    },
    onChangeTime($event, type) {
        const self = this;
        const lstMaterial = this.lstMaterial; 
        let timeSelected = [];
        if (type == 'am') {
            this.timeAmSelected.sort((o1, o2) => {
                return o1 - o2;
            });
            timeSelected = this.timeAmSelected;
        } else {
            this.timePmSelected.sort((o1, o2) => {
                return o1 - o2;
            });
            timeSelected = this.timePmSelected;
        }

        for (let i = 0; i < lstMaterial.length; i++) {
            const quantity = [];
            let quantity_tmp = [];

            if (type == 'am') {
                quantity_tmp = lstMaterial[i].quantityAm;
            } else {
                quantity_tmp = lstMaterial[i].quantityPm;
            }

            $.each(timeSelected, function (k, v) {
                const t = quantity_tmp.filter(function(o){
                    return parseFloat(v) == o.time && o.value > 0;
                })
                let val = '';
                if (t != undefined && t.length > 0) {
                    val = t[0].value;
                }

                if (val == '') {
                  // console.log(i);
                  // console.log(lstMaterial);
                  val = self.getCurrentTimeValue(lstMaterial[i].materialId, v);
                }

                quantity.push({time: parseFloat(v), value: val});
            });
            quantity.sort((o1, o2) => {
                return o1.time - o2.time;
            });

            if (type == 'am') {
                this.lstMaterial[i].quantityAm = quantity;
            } else {
                this.lstMaterial[i].quantityPm = quantity;
            }
            
            this.calcuTotalExport(i);
        }
    },
    getShrimpAge(calcuDate = '') {
        const item = this.crop;
        if (item == '') {
            return 0;
        }
        let calculateDate = calcuDate != '' ? calcuDate : moment().add('days', 1).format('YYYY-MM-DD');
        
        let shrimpAge = '';
        let dropDate = '';
        if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
            dropDate = moment(String(item.dropDateParent));
        } else if (item.dropDate != '' && item.dropDate != null) {
            dropDate = moment(String(item.dropDate));
        }
        if (dropDate != '') {
            let calculateDateMM = moment(String(calculateDate));
            let endDate = moment(String(calculateDate));
            if (item.endDate) {
                endDate = moment(String(item.endDate));
                if (endDate > calculateDateMM) endDate = calculateDateMM;
            }
            if (endDate > dropDate) {
                let dates = endDate.diff(dropDate, "days");
                if (dates >= 0) {
                    shrimpAge = dates;
                }
            }
        }
        this.createItem.shrimpAge = shrimpAge;
    },
    setTimeList() {
      for (let i = 1; i <= 12; i++) {
        this.timeAm.push({text: i + 'h', value: i, disabled: this.timeExported(i)});
      }
      for (let i = 13; i <= 24; i++) {
        this.timePm.push({text: i + 'h', value: i, disabled: this.timeExported(i)});
      }
    },
    reCalculate() {
      //
      // sum
      //
      this.lstMaterial = [];
      
      if (this.exportRequest.status > 2) {
        for (let i = 0; i < this.lstMaterialCurrent.length; i++) {
          this.lstMaterial.push(Object.assign({}, this.lstMaterialCurrent[i]));
        }
      } else {
        if (this.lstProcedureData.lstMaterial == undefined) {
            return false;
        }
        for (let i = 0; i < this.lstProcedureData.lstMaterial.length; i++) {
          this.lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));

          // const material = this.lstMaterialCurrent.find((v) => v.materialId === this.lstProcedureData.lstMaterial[i].materialId);
          // console.log(material);
          // if (material != undefined) {
          //   this.lstMaterial.push(Object.assign({}, material));
          // } else {
          //   this.lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));
          // }        
        }
      }

      // console.log(this.createItem.shrimpAge);
      for (let i = 0; i < this.lstMaterial.length; i++) {
        if (this.lstMaterial[i].total == undefined) {
          this.lstMaterial[i].total = 0;
          this.lstMaterial[i].price = 0;
          this.lstMaterial[i].amount = 0;

          for (let j = 0; j < this.lstProcedureData.lstChildrenDay.length; j++) {
            let procedureDay = this.lstProcedureData.lstChildrenDay[j];
            if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
              if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                continue;
              }
              let data = JSON.parse(procedureDay.data);
              let count = data[this.lstMaterial[i].materialId];
              if (count != undefined && count != null && count != "") {
                this.lstMaterial[i].total += parseFloat(count);
              }
            }
          }
          for (let j = 0; j < this.lstProcedureData.lstMotherDay.length; j++) {
            let procedureDay = this.lstProcedureData.lstMotherDay[j];
            if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
              if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                continue;
              }
              let data = JSON.parse(procedureDay.data);
              let count = data[this.lstMaterial[i].materialId];
              if (count != undefined && count != null && count != "") {
                this.lstMaterial[i].total += parseFloat(count);
              }
            }
          }
        }
      }
      //
      // remove item has total = 0 and not in material type
      //
      for (let i = this.lstMaterial.length - 1; i >= 0; i--) {
        if (this.lstMaterial[i].total == 0) {
          this.lstMaterial.splice(i, 1);
          continue;
        }
        let bRemove = true;
        for (let j = 0; j < this.lstMaterialType.length; j++) {
          if (this.lstMaterialType[j].categoryId == this.lstMaterial[i].typeId) {
            bRemove = false;
            break;
          }
        }
        if (bRemove) {
          this.lstMaterial.splice(i, 1);
        }
      }
      //
      // sort by typeId
      //
      this.lstMaterial.sort((o1, o2) => {
        if (o1.typeId == o2.typeId) {
          return o1.materialName.localeCompare(o2.materialName);
        } else {
          return o1.typeId - o2.typeId;
        }
      })

      for (let i = 0; i < this.lstMaterialType.length; i++) {
        this.lstMaterialType[i].count = 0;
        for (let j = 0; j < this.lstMaterial.length; j++) {
          if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
            this.lstMaterialType[i].count++;
          }
        }
        if (this.lstMaterialType[i].count == 0) {
          this.lstMaterial.push({
            typeId: this.lstMaterialType[i].categoryId,
            typeName: this.lstMaterialType[i].categoryName,
            row: 0
          })
        } else {
          for (let j = 0; j < this.lstMaterial.length; j++) {
            if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
              this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryName;
              this.lstMaterial[j].row = this.lstMaterialType[i].count;
              break;
            }
          }
        }

      }

      // filter total > 0
      this.lstMaterial = this.lstMaterial.filter(function (e) {
        return e.total != undefined && e.total > 0;
      });

      // filter type select
      const materialTypeSelected = this.materialTypeSelected;
      if (this.materialTypeSelected != '-1') {
          this.lstMaterial = this.lstMaterial.filter(function (e) {
              return materialTypeSelected.includes(e.typeId);
          });
      } else {
        this.lstMaterial = [];
      }

      // inventory
      const lstInventory = this.lstInventory;
      const lstMaterial = this.lstMaterial;
      if (lstInventory != undefined && lstMaterial != undefined) {
        for (let i = lstMaterial.length - 1; i >= 0; i--) {
          lstMaterial[i].quantityAm = [];
          lstMaterial[i].quantityPm = [];
          lstMaterial[i].total_export = '';
          lstMaterial[i].inventory = 0;

          const inv = lstInventory.filter(function(o) {
            return lstMaterial[i].materialId == o.materialId;
          });
          if (inv != undefined && inv[0] != undefined) {
            lstMaterial[i].inventory = inv[0].quantity;
          }

          // material price
          lstMaterial[i].price = 0;
          const matPrice = this.lstMaterialPrice.find((v) => v.materialId === lstMaterial[i].materialId);
          if (matPrice != undefined) {
            lstMaterial[i].price = matPrice.averagePrice;
          }
        }
      }

      this.lstMaterial = lstMaterial;
    },
    // calcuInventory() {
    //   const lstInventory = this.lstInventory;
    //   const lstMaterial = this.lstMaterial;

    //   $.each(lstMaterial, function (k, v) {
    //     const inv = lstInventory.filter(function (o) {
    //       return lstMaterial[k].materialId == o.materialId;
    //     });
    //     if (inv != undefined && inv[0] != undefined) {
    //       lstMaterial[k].inventory = inv[0].quantity;
    //     }
    //   });
    //   this.lstMaterial = lstMaterial;
    // },
    onInputChange($event) {
      const row = parseInt($event.target.getAttribute("data-row"));
      this.calcuTotalExport(row);
    },
    onInputChangeTextBoxFloat($event,row) {
      this.calcuTotalExport(row);
    },
    calcuTotalExport(row = 0) {
        const item = this.lstMaterial[row];
        const totalAm = item.quantityAm.reduce((n, {value}) => n + (value !='' ? parseFloat(value) : 0), 0);
        const totalPm = item.quantityPm.reduce((n, {value}) => n + (value !='' ? parseFloat(value) : 0), 0);

        const lstMaterial = this.lstMaterial;
        this.lstMaterial = [];
      //linhdx fix loi so luong vuot qua do du lieu dang 0.7000000000001
      //lstMaterial[row].total_export = parseFloat(totalAm) + parseFloat(totalPm);
      lstMaterial[row].total_export = Number((totalAm + totalPm).toFixed(2)) ;
        //
        this.lstMaterial = lstMaterial;
    },
    formatTimeSelected(item) {
      const timeAm = [];
      const timePm = [];

      item.quantityAm.forEach((v) => {
        timeAm.push(parseInt(v.time));
      });
      item.quantityPm.forEach((v) => {
        timePm.push(parseInt(v.time));
      });

      this.timeAmSelected = timeAm;
      this.timePmSelected = timePm;
    },
    rountDecimal(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },
    setIsEdit() {
      // let role = parseInt(this.$store.state.auth.user.role);
      let isEdit = false;
      if(this.showUpdate){
        isEdit = true;
      }
      this.isEdit = isEdit;
    },
    openDialogRejectApprove() {
      this.dialogRejectApprove = true;
    },
    closeDialogRejectApprove() {
      this.dialogRejectApprove = false;
    },
    openDialogCancelExport () {
      this.dialogCancelExport = true;
    },
    closeDialogCancelExport() {
      this.dialogCancelExport = false;
    },
    closeHistory(){
      this.historyDlg =false;
    },
    onChangeExportDate() {
        this.getShrimpAge(this.createItem.exportDate);
        this.reCalculate();
        this.onChangeTime('', 'am');
        this.onChangeTime('', 'pm');
    },
    onChangeMatType() {
        this.reCalculate();
        this.onChangeTime('', 'am');
        this.onChangeTime('', 'pm');
    },
    setMatTypeSelect() {
        const lstMaterial = [];
        if (this.lstProcedureData.lstMaterial == undefined) {
            return false;
        }
        for (let i = 0; i < this.lstProcedureData.lstMaterial.length; i++) {
          lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));
        }
        for (let i = 0; i < lstMaterial.length; i++) {
          lstMaterial[i].total = 0;

          for (let j = 0; j < this.lstProcedureData.lstChildrenDay.length; j++) {
            let procedureDay = this.lstProcedureData.lstChildrenDay[j];
            if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
              if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                continue;
              }
              let data = JSON.parse(procedureDay.data);
              let count = data[lstMaterial[i].materialId];
              if (count != undefined && count != null && count != "") {
                lstMaterial[i].total += parseFloat(count);
              }
            }
          }
          for (let j = 0; j < this.lstProcedureData.lstMotherDay.length; j++) {
            let procedureDay = this.lstProcedureData.lstMotherDay[j];
            if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
              if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                continue;
              }
              let data = JSON.parse(procedureDay.data);
              let count = data[lstMaterial[i].materialId];
              if (count != undefined && count != null && count != "") {
                lstMaterial[i].total += parseFloat(count);
              }
            }
          }
        }
        //
        // remove item has total = 0 and not in material type
        //
        for (let i = lstMaterial.length - 1; i >= 0; i--) {
          if (lstMaterial[i].total == 0) {
            lstMaterial.splice(i, 1);
            continue;
          }
          let bRemove = true;
          for (let j = 0; j < this.lstMaterialType.length; j++) {
            if (this.lstMaterialType[j].categoryId == lstMaterial[i].typeId) {
              bRemove = false;
              break;
            }
          }
          if (bRemove) {
            lstMaterial.splice(i, 1);
          }
        }

        let lstType = [];
        for (let i = lstMaterial.length - 1; i >= 0; i--) {
            lstType.push(lstMaterial[i].typeId)
        }
        lstType = lstType.filter((v, i, a) => a.indexOf(v) === i);
        let materialTypeAllyId = this.materialTypeAllyId;
        const lstMaterialTypeSelect = this.lstMaterialType.filter(function(o) {
            //linhdx them nhom và nhom
            //return lstType.includes(o.categoryId);
            return lstType.includes(o.categoryId) && o.parentId == materialTypeAllyId;
        });

        this.lstMaterialTypeSelect = lstMaterialTypeSelect;

        let materialTypeSelected = [];
        for (let i = this.lstMaterial.length - 1; i >= 0; i--) {
            materialTypeSelected.push(this.lstMaterial[i].typeId)
        }
        materialTypeSelected = materialTypeSelected.filter((v, i, a) => a.indexOf(v) === i);
        this.materialTypeSelected = materialTypeSelected;
    },
    getCurrentTimeValue(materialId, time) {
      let value = '';
      const material = this.lstMaterialCurrent.find((v) => v.materialId === materialId);
      if (material != undefined) {
        let quantity = material.quantityAm.find((v) => v.time === time);
        if (quantity != undefined) {
          value = quantity.value;
        } else {
          quantity = material.quantityPm.find((v) => v.time === time);
          if (quantity != undefined) {
            value = quantity.value;
          }
        }
      }
      return value;
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY');
    },
    getHistory(exportRequest) {
      axios.post(
          process.env.VUE_APP_API_URL + "/exportRequest/searchHistory?exportId=" + exportRequest.exportId).then(
          (data) => {
            this.lstHistory = data;
          }
      );
    },
    timeExported(t) {
      let exported = false;
      if (this.exportRequest.exportedTime != null) {
        const times = this.exportRequest.exportedTime.split(',');
        if (times.includes(t.toString())) {
          exported = true;
        }
      }
      return exported;
    },
    // getMaterialPrice() {
    //   axios.post(
    //       process.env.VUE_APP_API_URL + "/materialPrice/search?pageSize=-1&page=-1", {}
    //   )
    //       .then((data) => {
    //         if (data.items) {
    //           this.lstMaterialPrice = data.items;
    //           this.calcuPrice();
    //         }
    //       });
    // },
    calcuPrice() {
      for(let i = 0; i< this.lstMaterial.length; i++){
        let obj = this.lstMaterial[i];
        const matPrice = this.lstMaterialPrice.find((v) => v.materialId === obj.materialId);
        if (matPrice != undefined) {
          obj.price = matPrice.averagePrice;
          obj.amount = obj.total_export * obj.price;
        }
      }
    },
    exportStatusName() {
      const self = this;
      let name = '';
      const status = requestConstants.requestExportStatus.find(function (e) {
          return e.value == self.exportRequest.status;
      });
      if (status != undefined) {
          name = status.text;
      }
      return name;
    },
  },

  destroyed() {
  },
};
</script>
